<template>
  <roomInfoScreen :smile="true" :home_button="true">
    Thank you for starting your subscription
  </roomInfoScreen>
</template>

<script>
import roomInfoScreen from "@/components/roomInfoScreen.vue";

export default {
  name: "CheckoutSuccess",

  components: {
    roomInfoScreen,
  },
};
</script>

<style scoped>
</style>
